import React from 'react';
import styles from './investors-faq.module.scss';
import { useTranslation } from 'next-i18next';
import mainStyles from '../../../pages/investors/investors.module.scss';
import { Faq, FAQQuestion, FAQCustomIcon } from '@components/faq';
import { combineCN } from '@helpers/styles.helper';
import { environment } from '@environment';

const InvestorsFAQSection = () => {
	const { t } = useTranslation();
	const customIcons: FAQCustomIcon = {
		collapsed: (
			<img
				src={environment.images_cdn_url + '/investors/arrow.svg'}
				alt="expand"
				className={styles.arrowIcon}
			/>
		),
		expanded: (
			<img
				src={environment.images_cdn_url + '/investors/arrow.svg'}
				alt="collapse"
				className={`${styles.arrowIcon} ${styles.arrowExpanded}`}
			/>
		)
	};

	// build static FAQ questions from translations
	const faqQuestions: FAQQuestion[] = React.useMemo(() => {
		const questions: FAQQuestion[] = [];
		let index = 1;

		while (t(`ir_faq_q${index}`, { defaultValue: '' })) {
			const question = t(`ir_faq_q${index}`);
			const answer = t(`ir_faq_a${index}`);

			if (question && answer) {
				questions.push({
					id: `investor_faq_${index}`,
					title: question,
					body: answer
				});
			}

			index++;
		}

		return questions;
	}, [t]);

	return (
		<section className={combineCN(mainStyles.main_section_wrapper, styles.faq_wrapper)}>
			<h2 className={mainStyles.title}>{t('investor_relations_frequently_asked_questions')}</h2>
			<Faq
				staticQuestions={faqQuestions}
				showTitle={false}
				customIcon={customIcons}
				customStyles={{
					content: styles.faqContent,
					question: styles.faqQuestion,
					accordionPanel: styles.accordionPanel,
					answer: styles.faqAnswer
				}}
			/>
		</section>
	);
};

export default InvestorsFAQSection;
